<div class="container">
    <h1>404</h1>
    <h2>error: not found</h2>
</div>